import ESIInclude from '@JohnLewisPartnership/jl-esi-components';

export default ESIInclude;
